import { useCallback, useReducer } from 'react';

import { MetaTags } from '@redwoodjs/web';

import { SepaAgreementTables } from 'src/features/finance/sepaDirectDebits/components/SepaAgreementTables/SepaAgreementTables';
import SepaDDForm from 'src/features/finance/sepaDirectDebits/components/SepaForms/SepaDDForm';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

function DirectDebitsPage() {
    const [shouldRefetchTableData, triggerRefetchTableData] = useReducer((x) => x + 1, 0);

    const onSendSepaDD = useCallback(() => {
        triggerRefetchTableData();
    }, []);

    return (
        <PageContent
            heading="Setup New SEPA Direct Debits"
            subHeading="Add New SEPA Direct Debit for billing purposes"
        >
            <MetaTags
                title="Setup New SEPA Direct Debits"
                description="Setup New SEPA Direct Debits"
            />
            <SepaDDForm onSendSepaDD={onSendSepaDD} />
            <SepaAgreementTables shouldRefetch={shouldRefetchTableData} />
        </PageContent>
    );
}

export default DirectDebitsPage;
